export const GET_APPS_ID = 'GetAppsSection';
